import React from 'react';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import { Button, ButtonSize, ButtonType, ButtonVariant } from '@ids/react-button';
import SecondaryButton from '../../../../../Elements/ids/Buttons/SecondaryButton';

const RemoveAgentButtons = ({ closeView, onClickEvent }) => {
  return (
    <>
      <SecondaryButton text={formatMessage(Messages.common_cancel)} onClickEvent={closeView} />
      <Button size={ButtonSize.MEDIUM} type={ButtonType.FILLED} variant={ButtonVariant.DANGER} onClick={onClickEvent}>
        {formatMessage(Messages.employerPage_removeAgent_accept)}
      </Button>
    </>
  );
};

export default RemoveAgentButtons;
